import { AccordionProfessionTitle as AccordionProfessionTitleVM } from 'shell/view-models/accordion-profession-title';
import { OtherDatas } from 'shell/models/person/shared';

export const transformProfessionTitle = (
  values: AccordionProfessionTitleVM | undefined
): OtherDatas | undefined => {
  const result: OtherDatas | undefined = values
    ? {
        condizioneNonProfessionale: values?.unprofessionalCondition || '',
        // descrizioneCondizioneNonProfessionale: '', TODO WITH SELECT
        // descrizionePosizioneProfessionale: '', TODO WITH SELECT
        // descrizioneTitoloStudio: '', TODO WITH SELECT
        posizioneProfessionale: values?.professionalPosition || '',
        titoloStudio: values?.educationalQualification || '',
      }
    : undefined;

  return result;
};
